import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function getUtteranceFlagTaggedData(category, clientKey, reviewed, currentPage, UtteranceFlagFilterEnabled, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.get("api/getUtteranceFlagTaggedData", {
      params: {
        category,
        clientkey: clientKey,
        reviewed,
        page: currentPage,
        filter: UtteranceFlagFilterEnabled,
        userKey,
      },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
